var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50762 15.5849H9.76244C10.0562 15.5849 10.2376 15.4035 10.2376 15.1098V13.7275C10.2376 11.6368 13.2785 10.2892 13.2785 6.55707C13.2785 2.62629 10.6176 0 6.63484 0C2.65209 0 0 2.62629 0 6.55744C0 10.2892 3.03249 11.6368 3.03249 13.7275V15.1098C3.03249 15.4035 3.22232 15.5849 3.50762 15.5849ZM3.8272 17.9178H9.44286C9.88334 17.9178 10.2376 17.5551 10.2376 17.1057C10.2376 16.6564 9.88334 16.2937 9.44249 16.2937H3.8272C3.38672 16.2937 3.03249 16.6568 3.03249 17.1057C3.03249 17.5554 3.38635 17.9178 3.8272 17.9178ZM6.63484 20C7.82727 20 8.66511 19.4556 8.75136 18.6177H4.51833C4.5961 19.4556 5.43394 20 6.63484 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogic);
export default __webpack_public_path__ + "static/media/Logic.90d9325d7e1136c122240ab812edcb97.svg";
export { ForwardRef as ReactComponent };